import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=d23798ae&scoped=true&lang=pug&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=d23798ae&prod&lang=sass&scoped=true&"
import style1 from "./ProjectList.vue?vue&type=style&index=1&id=d23798ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23798ae",
  null
  
)

export default component.exports